import { createSlice } from '@reduxjs/toolkit';

type userInterface = {
  access: string;
  refresh: string;
  uid: number;
};

type workspace = {
  name?: string;
  refresh?: string;
  workspace_id?: string;
  is_active: boolean;
  user: userInterface;
};

export type workspaceState = workspace[];

const initialState: workspaceState = [];

const updateOrAddWorkspace = (workspace: workspace, remove?: boolean) => {
  const workspaces = localStorage.getItem('workspaces') || '';
  let existingWorkspaces = workspaces ? JSON.parse(workspaces) : [];
  const existingWorkspaceIndex = existingWorkspaces.findIndex((ws: any) => ws.workspace_id === workspace.workspace_id);
  if (remove) {
    // delete workspace from localStorage if logout
    existingWorkspaces = existingWorkspaces.filter((ws: workspace) => ws.workspace_id !== workspace.workspace_id);
    // check if last-active workspace is equal to session workspace
    if (localStorage.getItem('last-active:workspace') === sessionStorage.getItem('workspace')) {
      // assign a new active workspace if there's any;
      if (existingWorkspaces.length) {
        localStorage.setItem('last-active:workspace', existingWorkspaces[0]?.workspace_id);
      }
    }
    sessionStorage.clear();
  } else {
    if (existingWorkspaceIndex !== -1) {
      existingWorkspaces[existingWorkspaceIndex] = workspace;
    } else {
      existingWorkspaces.push(workspace);
    }
  }
  localStorage.setItem('workspaces', JSON.stringify(existingWorkspaces));
};

const workspaceSlice = createSlice({
  name: 'workspace',
  initialState,
  reducers: {
    addWorkspace: (state, action) => {
      const { workspace, ...resultObject } = action.payload;
      resultObject.id = resultObject.user_id;
      workspace.user = resultObject;
      state.push(workspace);
      sessionStorage.setItem('workspace', workspace.workspace_id);
      sessionStorage.setItem('workspace-url', workspace.url);
      localStorage.setItem('last-active:workspace', workspace.workspace_id);
      updateOrAddWorkspace(workspace);
    },
    removeWorkspace: (state, action) => {
      const workspace = action.payload;
      const index = state.findIndex((workspace) => workspace.workspace_id === workspace.workspace_id);
      if (index !== -1) {
        state.splice(index, 1);
        updateOrAddWorkspace(workspace, true);
      }
    },
    updateWorkspaceToken: (state, action) => {
      const { access, refresh, workspaceId } = action.payload;
      const workspace = state.find((workspace) => workspace.workspace_id === workspaceId);
      if (workspace) {
        // Update the workspace state access token and refresh token
        workspace.user.access = access;
        workspace.user.refresh = refresh;
        updateOrAddWorkspace(workspace);
      }
    }
  }
});

export const { addWorkspace, removeWorkspace, updateWorkspaceToken } = workspaceSlice.actions;

export const workspaceReducer = workspaceSlice.reducer;
